function loadImages(element, idx) {
  if (!shouldLoadMoreImages(element, idx)) {
    document.addEventListener('scroll', onScrollHandler);
  } else {
    handleGalleryState(element);
  }

  function onScrollHandler() {
    if (shouldLoadMoreImages(element, idx)) {
      document.removeEventListener('scroll', onScrollHandler);

      handleGalleryState(element);
    }
  }
}

function shouldLoadMoreImages(element, idx) {
  const rect = element.getBoundingClientRect();

  if ((rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) + 100)) {
    galleryImagesDataArray[idx].shift();

    galleryImagesDataArray[idx].forEach(image => {
      const imageElement = document.createElement('img');

      imageElement.alt = '';
      imageElement.decoding = 'async';
      imageElement.src = image;
      imageElement.style.opacity = '0';

      element.appendChild(imageElement);
    })

    return true;
  }

  return false;
}

function handleGalleryState(element) {
  let currentImageIndex;

  const images = element.querySelectorAll('img');
  const dots = element.querySelectorAll('.navigation-dot');
  const numberOfImages = images.length;

  initNavigationFunctions();
  initSwipeEvents();
  setActiveImage(0);

  window.addEventListener('resize', () => {
    element.style.height = `${images[currentImageIndex].clientHeight}px`;
  })

  function setActiveImage(activeImageIndex) {
    currentImageIndex = activeImageIndex;

    dots.forEach((dot, idx) => {
      if (idx === currentImageIndex) {
        dot.classList.add('active-dot');
      } else {
        dot.classList.remove('active-dot');
      }
    })

    images.forEach((image, idx) => {
      if (idx === currentImageIndex) {
        element.style.height = `${image.clientHeight}px`;
      }

      image.style.opacity = idx === currentImageIndex ? '1' : '0';
    })
  }

  function nextArrowClick() {
    return currentImageIndex + 1 <= numberOfImages - 1 ? currentImageIndex + 1 : 0;
  }

  function prevArrowClick() {
    return currentImageIndex - 1 >= 0 ? currentImageIndex - 1 : numberOfImages - 1;
  }

  function initNavigationFunctions() {
    const prevArrow = element.querySelector('.arrow-wrapper-left');
    const nextArrow = element.querySelector('.arrow-wrapper-right');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        setActiveImage(prevArrowClick());
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        setActiveImage(nextArrowClick());
      });
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        setActiveImage(idx);
      })
    })
  }

  function initSwipeEvents() {
    let startX = 0;
    let endX = 0;
    let isMoving = false;

    const minSwipeDistance = 100;

    element.addEventListener('touchstart', function (event) {
      isMoving = false;
      startX = event.touches[0].clientX;
    });

    element.addEventListener('touchmove', function (event) {
      endX = event.touches[0].clientX;
      isMoving = true;
    });

    element.addEventListener('touchend', function () {
      if (isMoving) {
        const distanceX = endX - startX;

        if (distanceX > minSwipeDistance) {
          setActiveImage(prevArrowClick());
        } else if (distanceX < -minSwipeDistance) {
          setActiveImage(nextArrowClick());
        }
      }
    });
  }
}

export function initPhotoGalleries() {
  document.querySelectorAll('.photo-gallery').forEach((c, idx) => loadImages(c, idx));
}
